/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-05 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';

class NoResult extends Component {
  render() {
    const { i18n } = this.props;
    return (
      <div>
        <div className="BC-RecomendGeneralSetting_ProductList-NoProduct">
          {i18n.translate(
            'AdminHTML.Recommendation.GeneralSettings.IncludeProducts.noProduct'
          )}
        </div>
      </div>
    );
  }
}

export default withI18n()(NoResult);
